import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import "./phoneCallModal.scss";
import acceptRejectRequest from "../../service/api/ticket/acceptRejectRequest";
import { callFalse } from "../../feature/userData/userData";
import phoneRing from "../../media/sounds/OfficialTone.mp3";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import CustomButton from "../../jsx/components/button/customButton";
import ErrorResponseModal from "../errorModal/errorResponseModal";

const PhoneCallModal = ({ openCallUI, dataRecieved, errorFunction }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { notificationTypeRedux, loaderTime } = useSelector(
    (state) => state.user
  );

  const [connectingScreen, setConnectingScreen] = useState(false);
  const [checkIntervalFlag, setCheckIntervalFlag] = useState(true);

  const phoneRingSoundRef = useRef(phoneRing);
  const [errorModalStatus, setErrorModalStatus] = useState(false)

  const [errorMessage, setErrorMessage] = useState("");
  const [serviceSummaryMetaData, setServiceSummaryMetaData] = useState({});
  const [imagesArray, setImagesArray] = useState([]);

  // Fixes Python-ish arrays like your image_urls example
  const parsePythonishArray = (val) => {
    if (Array.isArray(val)) return val;
    if (typeof val !== 'string') return [];

    // fast path: already valid JSON
    try {
      const arr = JSON.parse(val);
      return Array.isArray(arr) ? arr : [];
    } catch { }

    // patch Python-ish -> JSON-ish
    try {
      const patched = val
        .replace(/Decimal\('([^']+)'\)/g, '$1') // keep as plain number string
        .replace(/\bNone\b/g, 'null')
        .replace(/\bTrue\b/g, 'true')
        .replace(/\bFalse\b/g, 'false')
        .replace(/'/g, '"'); // last: convert single -> double quotes carefully

      const arr = JSON.parse(patched);
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      console.warn('Unable to parse image_urls payload:', e);
      return [];
    }
  };


  useEffect(() => {

    const data = dataRecieved?.data;

    if (data || typeof data === 'object' || Object.keys(data || {})?.length > 0) {

      try {
        console.log(dataRecieved?.data, "dataRecieved");
        // console.log('image_urls', JSON.parse(dataRecieved?.data?.image_urls || '[]'));

        const images = parsePythonishArray(dataRecieved?.data.image_urls);

        // console.log(images, 'images Array');

        if (images?.length > 0) {
          setImagesArray(images);
        }

        if (dataRecieved?.data?.summary_data) {

          // debugger;
          // const finalObject = JSON.parse(JSON.parse(res?.data?.summary_meta_data));
          // const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));

          const finalObjectTwo = (JSON.parse(dataRecieved?.data?.summary_data));

          let finalObject = {};

          // if(!Object.keys(finalObjectTwo).length > 0) {
          if (typeof (finalObjectTwo) === 'string') {
            finalObject = JSON.parse(finalObjectTwo);
          }

          console.log(finalObject, "finalObject");
          console.log(finalObjectTwo, "finalObjectTwo");

          if (Object.keys(finalObject).length > 0) {

            setServiceSummaryMetaData(finalObject);


          } else if (Object.keys(finalObjectTwo).length > 0) {
            setServiceSummaryMetaData(finalObjectTwo);

          } else {
            setServiceSummaryMetaData({});
          }

        }
      } catch (error) {
        // Prevent the effect from taking down the whole tree
        console.error('Failed to handle socket payload:', error);
        setServiceSummaryMetaData({});
      }

    }
  }, [dataRecieved])

  function acceptCall() {
    if (notificationTypeRedux == 2) {
      setConnectingScreen(true);
      setCheckIntervalFlag(false);
      phoneRingSoundRef.current.pause();
      phoneRingSoundRef.current.currentTime = 0;
      let details = new FormData();
      details.append("meta_data", localStorage.getItem("metaData"));
      details.append("accept_reject_flag", 1);
      dispatch(
        acceptRejectRequest(
          details,
          (res) => {
            localStorage.setItem("triggerFlag", 0);

            dispatch(callFalse());
            localStorage.setItem("roomCode", res.data.data.room_id);
            setConnectingScreen(true);
            navigate("/videoCall");
          },
          (err) => {
            errorFunction(err.data.message)
            setConnectingScreen(false);
            dispatch(callFalse());
          }
        )
      );
    }
    if (notificationTypeRedux == 0) {
      dispatch(callFalse());
      navigate("/videoCall");
    }
  }

  function rejectCall() {
    if (notificationTypeRedux == 2) {
      phoneRingSoundRef.current.pause();
      phoneRingSoundRef.current.currentTime = 0;

      dispatch(callFalse());
      let details = new FormData();
      details.append("meta_data", localStorage.getItem("metaData"));
      details.append("accept_reject_flag", 0);
      dispatch(
        acceptRejectRequest(
          details,
          (res) => {
            console.log(res);
          },
          (err) => {
            alert(err.statusText);
            console.log(err);
          }
        )
      );
    }
    if (notificationTypeRedux == 0) {
      dispatch(callFalse());
    }
  }
  function callIngnored() {
    phoneRingSoundRef.current.pause();
    phoneRingSoundRef.current.currentTime = 0;
    dispatch(callFalse());
    let details = new FormData();
    details.append("meta_data", localStorage.getItem("metaData"));
    details.append("accept_reject_flag", 0);
  }

  useEffect(() => {
    phoneRingSoundRef.current.play();
  }, []);
  useEffect(() => {
    console.log("OPened");
    const timer = setTimeout(() => {
      // Code to execute after 30 seconds
      if (checkIntervalFlag) {
        callIngnored();
      }
    }, loaderTime - 3000);
    // Clear the timer when the component unmounts or changes
    return () => clearTimeout(timer);
  }, []);

  function handleClose() {
    setConnectingScreen(false);
  }
  const [resendCodeTimer, setResendCodeTimer] = useState(
    (loaderTime - 3000) / 1000
  );
  const [resendCodeCheck, setResendCodeCheck] = useState(true);
  const [imgMaxHeight, setImgMaxHeight] = useState(0);
  const [imgMaxWidth, setImgMaxWidth] = useState(0);
  const intervalId = useRef(null);
  const checkHW = useRef(null);
  useEffect(() => {
    const height = checkHW.current.getBoundingClientRect().height;
    const width = checkHW.current.getBoundingClientRect().width;
    setImgMaxWidth(width);
    setImgMaxHeight(height);
    if (resendCodeCheck && resendCodeTimer > 0) {
      intervalId.current = setInterval(
        () => setResendCodeTimer((prev) => prev - 1),
        1000
      );
    } else if (!resendCodeCheck || resendCodeTimer === 0) {
      clearInterval(intervalId.current);
    }

    if (resendCodeTimer === 0) {
      setResendCodeCheck(false);
    }
    return () => clearInterval(intervalId.current);
  }, [resendCodeCheck, resendCodeTimer]);

  window.addEventListener("resize", () => {
    const height = checkHW?.current?.getBoundingClientRect()?.height;
    const width = checkHW?.current?.getBoundingClientRect()?.width;
    setImgMaxWidth(width);
    setImgMaxHeight(height);
  });

  // new code for the multiple attachments
  const [attachImageIndex, setAttachImageIndex] = useState(0);

  const handleImageIndex = (index) => {
    setAttachImageIndex(index);
  }

  const handlePrevAttachImg = () => {
    if (attachImageIndex !== 0) {
      setAttachImageIndex(attachImageIndex - 1)
    }
  }
  const handleNextAttachImg = () => {
    if (attachImageIndex <= imagesArray?.length - 1) {
      setAttachImageIndex(attachImageIndex + 1)
    }
  }



  // Zoom functionality for the images
  // State to hold the scale value
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);

  // Function to handle the change in range input
  const handleZoomChange = (event) => {
    setScale(event.target.value);
  };

  // Start dragging
  const handleDragStart = (event) => {
    event.preventDefault();
    setDragging(true);
    // setPosition({
    //     ...position, // Keep the previous position
    //     startX: event.clientX - position.x, // Calculate initial start position
    //     startY: event.clientY - position.y,
    // });
    const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
    const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

    setPosition({
      ...position,
      startX: clientX - position.x,
      startY: clientY - position.y,
    });
  };

  // Handle dragging
  const handleDragging = (event) => {
    if (dragging) {
      // setPosition({
      //     ...position,
      //     x: event.clientX - position.startX,
      //     y: event.clientY - position.startY,
      // });
      const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
      const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

      setPosition({
        ...position,
        x: clientX - position.startX,
        y: clientY - position.startY,
      });
    }
  };

  // Stop dragging
  const handleDragEnd = () => {
    setDragging(false);
  };

  // Reset image
  const handleResetImage = () => {
    setScale(1);
    setPosition({ x: 0, y: 0 });
  }

  useEffect(() => {
    handleResetImage();
    setIsLoadingImg(true);
  }, [attachImageIndex]);

  // Loading effect for the images
  const [isLoadingImg, setIsLoadingImg] = useState(true);

  const handleImageLoaded = () => {
    setIsLoadingImg(false);
  };

  const handleImageError = () => {
    console.error('Failed to load the image.');
    setIsLoadingImg(false);
  };

  return (
    <>
      <audio ref={phoneRingSoundRef} src={phoneRing} loop autoPlay />

      {
        <>
          <Modal className="fade" size="lg" show={true} centered>
            <div className="row p-3">
              <div className="col-6 d-flex">
                <div
                  className="col-12 px-0"
                  ref={checkHW}
                  style={{ background: "#AAAAAA", position: "relative" }}
                >
                  {/* This image url is working but old code*/}
                  {/* <img
                    alt=""
                    className="d-flex justify-content-center"
                    src={dataRecieved?.data?.image_url}
                    style={{
                      maxWidth: imgMaxWidth + "px",
                      maxHeight: imgMaxHeight + "px",
                      width: "100%",
                      height: '100%',
                      objectFit: 'contain'
                    }}
                  /> */}

                  <div
                    className="w-100 h-100 position-relative d-flex align-items-center justify-content-center"
                    style={{
                      background: "#AAA",
                      // borderRadius: "15px 0 0 15px",
                    }}>


                    {imagesArray?.length > 0 &&
                      <div
                        className="align-items-center bg-black d-flex fs-7 justify-content-center position-absolute px-3 py-2 w-100"
                        style={{ bottom: "0px", left: "50%", transform: "translateX(-50%)", background: 'rgba(244, 248, 255, 1)', zIndex: 1 }}
                      >
                        {/* New image pagination */}
                        <div className="border rounded d-flex " style={{ height: '33px' }}>
                          <div
                            onClick={() => {
                              handlePrevAttachImg()
                            }}
                            className="d-flex justify-content-center align-items-center cursor-pointer border-end text-hovered overlay-action-btn fs-5 text-black"
                            style={{
                              width: '30px',
                              pointerEvents: attachImageIndex === 0 ? 'none' : 'auto',
                              opacity: attachImageIndex === 0 ? '0.5' : '1'
                            }}
                          >
                            <i class="bi bi-chevron-left"></i>
                          </div>
                          <div className="d-flex justify-content-center align-items-center" style={{ width: '50px' }}>
                            <span className="fs-5 font-w600" style={{ color: '#FF8934' }}>{`${attachImageIndex + 1}`}</span> &nbsp;{`/`}&nbsp;
                            <span className="fs-5 font-w600">{`${imagesArray?.length}`}</span>
                          </div>
                          <div
                            onClick={() => {
                              handleNextAttachImg()
                            }}
                            className="d-flex justify-content-center align-items-center border-start cursor-pointer text-hovered overlay-action-btn fs-5 text-black"
                            style={{
                              width: '30px',
                              pointerEvents: (attachImageIndex >= imagesArray?.length - 1) ? 'none' : 'auto',
                              opacity: (attachImageIndex >= imagesArray?.length - 1) ? '0.5' : '1'
                            }}
                          >
                            <i class="bi bi-chevron-right"></i>
                          </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-center ps-2">
                          <span className="fs-6 font-w600 pe-1">{`Zoom`}</span>
                          <input
                            className=""
                            type="range"
                            min="1"
                            max="3"
                            value={scale}
                            step="0.1"
                            onChange={handleZoomChange}
                            style={{
                              width: '80px',
                              margin: '20px 0',
                              cursor: 'pointer',
                              background: 'linear-gradient(to right, #ddd 0%, #ddd 100%)',
                              borderRadius: '5px',
                              height: '4px',
                              outline: 'none',
                              opacity: '0.7',
                              transition: 'opacity 0.2s',
                            }}
                          />
                          {(scale !== 1 || position.x !== 0 || position.y !== 0) &&
                            <div className=' ms-2'>
                              <div className="tooltipCustom">
                                <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Reset photo"}</span>
                                <i
                                  class="bi bi-arrow-clockwise fs-4 text-black text-hovered cursor-pointer"
                                  onClick={() => {
                                    handleResetImage();
                                  }}
                                ></i>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }


                    {imagesArray?.length > 0 ? (
                      <div
                        // ref={imageRef}
                        className="align-items-center border-end d-flex  justify-content-center "
                      >
                        {isLoadingImg &&
                          <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              maxWidth: `${imgMaxWidth}px`,
                              maxHeight: `${imgMaxHeight}px`,
                              minWidth: `${imgMaxWidth}px`,
                              minHeight: `${imgMaxHeight < 251 ? '250px' : `${imgMaxHeight}px`}`,
                              width: "100%",
                              height: "100%",
                            }}
                          >
                            <Spinner animation="border" size="lg" style={{}} />
                          </div>
                        }
                        <div
                          className="overflow-hidden"
                          style={{ cursor: dragging ? 'grabbing' : 'grab' }}
                          onMouseMove={handleDragging}
                          onMouseLeave={handleDragEnd}
                          onMouseUp={handleDragEnd}
                          onTouchMove={handleDragging}
                          onTouchEnd={handleDragEnd}
                        >
                          <img
                            src={imagesArray?.[attachImageIndex]?.url}
                            alt=""
                            className=""
                            onLoad={handleImageLoaded}
                            onError={handleImageError}
                            onMouseDown={handleDragStart}
                            onTouchStart={handleDragStart}
                            style={{
                              maxWidth: `${imgMaxWidth}px`,
                              maxHeight: `${imgMaxHeight}px`,
                              minWidth: `${imgMaxWidth}px`,
                              minHeight: `${imgMaxHeight < 251 ? '250px' : `${imgMaxHeight}px`}`,
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              // borderRadius: "15px 0 0 15px",
                              transition: 'transform 0.25s ease',
                              transformOrigin: 'center',
                              transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
                              cursor: dragging ? 'grabbing' : 'grab',
                              display: isLoadingImg ? 'none' : 'block'
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className="fs-1 text-white border-end d-flex  justify-content-center align-items-center"
                        style={{
                          maxWidth: `${imgMaxWidth}px`,
                          maxHeight: `${imgMaxHeight}px`,
                          minWidth: `${imgMaxWidth}px`,
                          minHeight: `${imgMaxHeight < 251 ? '250px' : `${imgMaxHeight}px`}`,
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <i class="bi bi-file-image-fill"></i>
                      </div>
                    )}

                  </div>

                  {dataRecieved?.data?.product_type &&
                    <span
                      style={{ position: "absolute", top: "6px", left: "6px" }}>
                      <span
                        className="fs-7 px-2 py-1 w-100"
                        style={{
                          color: "grey",
                          background: "white",
                          borderRadius: "20px",
                        }}>
                        {dataRecieved?.data?.product_type}
                      </span>
                    </span>
                  }

                </div>
              </div>

              <div className="col-6">
                <div
                  className=" px-0 h-100"
                  style={{ display: "flex", flexDirection: "column" }}>
                  <div
                    className="py-2 px-3"
                    style={{ background: "lightgray" }}>
                    <div className="m-0 row">
                      <div className="col-6 d-flex fs-4 justify-content-start px-0 text-black">
                        <span className="">
                          <i className="bi bi-megaphone-fill cursor-pointer"></i>
                        </span>
                      </div>
                      <div className="col-6 d-flex fs-4 justify-content-end px-0 text-black">
                        <span
                          className=""
                          onClick={() => {
                            dispatch(callFalse());
                          }}
                        >
                          <i className="bi bi-x-lg cursor-pointer"></i>
                        </span>
                      </div>
                    </div>

                    <div className="mx-0 row ">
                      <span className="col-12 font-w600 fs-4 px-0 text-center text-black ">
                        Time to respond: {" "}
                        {resendCodeTimer > 9
                          ? resendCodeTimer
                          : "0" + resendCodeTimer}
                      </span>
                    </div>
                    <div className="mx-0 row mb-4">
                      <span className=" fs-6 px-0 text-center text-gray text-center">
                        You’ve been invited to this service request
                      </span>
                    </div>
                  </div>
                  <div
                    className="row mx-0 mt-2"
                    style={{ flex: "1", alignItems: "end" }}>
                    <div className="row px-3" style={{ minHeight: "300px" }}>
                      <div className="col-12 px-0 fs-7  mb-2">
                        <div className="row m-1">
                          <div className="row mx-0">
                            <div className="col-6 d-flex justify-content-start align-items-center fs-7">
                              {new Date(
                                dataRecieved?.data?.created_date_dtm * 1000
                              ).toLocaleString("en-US", {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                              })}
                            </div>
                            <div className="col-6 d-flex justify-content-end align-items-center fs-7">
                              {dataRecieved?.data?.display_id_int}
                            </div>
                          </div>
                          <div className="row mx-0 mb-2">
                            <div
                              className="col-12 d-flex justify-content-start align-items-center fs-3 pt-3"
                              style={{ fontWeight: "700", color: "black" }}>
                              {dataRecieved?.data?.problem_description}{" "}
                            </div>
                          </div>

                          {serviceSummaryMetaData?.recognized_image_summary &&
                            <div className="row mx-0">
                              <div className="col-12 ">
                                <span className="fs-5 text-black font-w600">{`Image summary: `}</span>
                              </div>

                              <div className="col-12 ">
                                <span className="fs-5">{`${serviceSummaryMetaData?.recognized_image_summary}`}</span>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    <div className="row px-3">
                      <div className="col-12 col-sm-6 px-0 fs-7  mb-2">
                        <div className="row m-1">
                          <CustomButton
                            needIcon={true}
                            iconClassName={"bi-check2"}
                            buttonName={"Accept"}
                            onClick={() => {
                              acceptCall();
                            }}
                            style={{
                              width: "100%",
                              background: "green",
                              border: "1px solid green",
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-12 col-sm-6 px-0 fs-7  mb-2">
                        <div className="row m-1">
                          <CustomButton
                            needIcon={true}
                            onClick={() => {
                              rejectCall();
                            }}
                            iconClassName={"bi-x"}
                            buttonName={"Decline"}
                            style={{
                              width: "100%",
                              background: "red",
                              border: "1px solid red",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </>
      }

      <Modal
        show={false}
        dialogClassName="modal-90w"
        className="bottom-right-corner">
        <Modal.Body>
          <div
            className="phone-call-modal-header"
            style={{ display: "flex", justifyContent: "center" }}>
            <p className="phone-call-modal-header-title">
              {localStorage.getItem("callingName") + " " + "is calling you"}
            </p>
          </div>
          <div className="phone-call-modal-avatar-section"></div>

          <div className="phone-call-modal-footer">
            <Button
              onClick={() => {
                acceptCall();
              }}
              className=""
              style={{ background: "green", border: "none" }}>
              <i className="bi bi-camera-video-fill" /> Accept
            </Button>

            <Button
              onClick={() => {
                rejectCall();
              }}
              className=""
              style={{ background: "red", border: "none" }}>
              <i class="bi bi-telephone-fill" /> Decline
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={connectingScreen}
        dialogClassName="modal-90w"
        className="centeral-modal .modal-dialog">
        <Modal.Body>Hold on! we are connecting you.</Modal.Body>
      </Modal>

    </>
  );
};

export default PhoneCallModal;
